import React from 'react';
import styles from './TypographyEditor.module.css';

interface TypographyEditorProps {
  fontFamily: string;
  fontSize: number;
  lineHeight: number;
  fontWeight: number;
  onChange: (field: keyof TypographyEditorProps, value: string | number) => void;
  defaults: {
    fontFamily: string;
    fontSize: number;
    lineHeight: number;
    fontWeight: number;
  };
}

const FONT_FAMILIES = [
  { value: 'system-ui', label: 'System UI' },
  { value: '-apple-system', label: 'Apple System' },
  { value: 'BlinkMacSystemFont', label: 'BlinkMacSystemFont' },
  { value: 'Segoe UI', label: 'Segoe UI' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Helvetica Neue', label: 'Helvetica Neue' },
  { value: 'Arial', label: 'Arial' },
  { value: 'sans-serif', label: 'Sans Serif' },
];

const FONT_WEIGHTS = [
  { value: 300, label: 'Light' },
  { value: 400, label: 'Regular' },
  { value: 500, label: 'Medium' },
  { value: 600, label: 'Semibold' },
  { value: 700, label: 'Bold' },
];

export const TypographyEditor: React.FC<TypographyEditorProps> = ({
  fontFamily,
  fontSize,
  lineHeight,
  fontWeight,
  onChange,
  defaults,
}) => {
  return (
    <div className={styles.typographyEditor}>
      <div className={styles.formGroup}>
        <label>Font Family</label>
        <select
          value={fontFamily}
          onChange={(e) => onChange('fontFamily', e.target.value)}
          className={styles.select}
        >
          {FONT_FAMILIES.map((font) => (
            <option key={font.value} value={font.value}>
              {font.label}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.formGroup}>
        <label>Font Size (px)</label>
        <div className={styles.sliderContainer}>
          <input
            type="range"
            min="12"
            max="24"
            step="0.5"
            value={fontSize}
            onChange={(e) => onChange('fontSize', parseFloat(e.target.value))}
            className={styles.slider}
          />
          <input
            type="number"
            min="12"
            max="24"
            step="0.5"
            value={fontSize}
            onChange={(e) => onChange('fontSize', parseFloat(e.target.value) || defaults.fontSize)}
            className={styles.numberInput}
          />
        </div>
      </div>

      <div className={styles.formGroup}>
        <label>Line Height</label>
        <div className={styles.sliderContainer}>
          <input
            type="range"
            min="1"
            max="2"
            step="0.05"
            value={lineHeight}
            onChange={(e) => onChange('lineHeight', parseFloat(e.target.value))}
            className={styles.slider}
          />
          <input
            type="number"
            min="1"
            max="2"
            step="0.05"
            value={lineHeight}
            onChange={(e) => onChange('lineHeight', parseFloat(e.target.value) || defaults.lineHeight)}
            className={styles.numberInput}
          />
        </div>
      </div>

      <div className={styles.formGroup}>
        <label>Font Weight</label>
        <select
          value={fontWeight}
          onChange={(e) => onChange('fontWeight', parseInt(e.target.value))}
          className={styles.select}
        >
          {FONT_WEIGHTS.map((weight) => (
            <option key={weight.value} value={weight.value}>
              {weight.label}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.preview}>
        <label>Preview</label>
        <div
          className={styles.previewText}
          style={{
            fontFamily,
            fontSize: `${fontSize}px`,
            lineHeight,
            fontWeight,
          }}
        >
          The quick brown fox jumps over the lazy dog.
          <br />
          1234567890
        </div>
      </div>
    </div>
  );
};
